import * as React from 'react';
import styled from 'styled-components';
import { FormGroup, QRGenerator, themeUtils as tu, useTheme } from '@zen-common/components-base';

export default function QRCodeFG({ value, expanded, onQrClick }) {
  const theme = useTheme();

  return (
    <StyledFG $expanded={expanded}>
      <ExpandableQr
        onClick={onQrClick}
        value={JSON.stringify(value)}
        includeMargin
        renderAs="svg"
        bgColor={tu.color('text')({ theme })}
        $expanded={expanded}
      />
    </StyledFG>
  );
}

const StyledFG = styled(FormGroup)`
  justify-content: center;
  display: ${(p) => (p.$expanded ? 'flex' : 'block')};
`;
const ExpandableQr = styled(QRGenerator)`
  width: ${(p) => (p.$expanded ? '100%' : 'auto')};
  height: ${(p) => (p.$expanded ? '100%' : 'auto')};
  max-width: 500px;
  max-height: 500px;
`;
